import s from '../EventWizardModal.module.scss';

interface StepPlanProps {
  planError: string | null;
  aiLoading: boolean;
  tasksAiLoading: boolean;
  onRetry: () => void;
  children: React.ReactNode;
}

export function StepPlan({
  planError,
  aiLoading,
  tasksAiLoading,
  onRetry,
  children,
}: StepPlanProps) {
  const showRetry = !!planError && !aiLoading && !tasksAiLoading;

  return (
    <>
      <div className={s.stepHeaderInline}>
        {showRetry && (
          <button type="button" className={s.aiCta} onClick={onRetry}>
            <span className={s.aiCtaIcon}>✨</span>
            <span className={s.aiCtaLabel}>Retry AI Plan</span>
          </button>
        )}
      </div>
      {showRetry && <span className={s.aiCoverErrorText}>{planError}</span>}
      {children}
    </>
  );
}
